'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');let

UserInfo=function(){
function UserInfo(
firstName,
lastName,
email,
phone,
role,
fatigueMeterType)




{let enabledFeatures=arguments.length>6&&arguments[6]!==void 0?arguments[6]:[];let isPrimary=arguments.length>7&&arguments[7]!==void 0?arguments[7]:!1;let authConfigName=arguments[8];let id=arguments.length>9&&arguments[9]!==void 0?arguments[9]:void 0;let temporaryPassword=arguments.length>10&&arguments[10]!==void 0?arguments[10]:void 0;_classCallCheck(this,UserInfo);
_.ensureInstanceOf('string',firstName);
_.ensureInstanceOf(['string','nullable'],lastName);
_.ensureInstanceOf('string',email);
_.ensureInstanceOf(['string','nullable'],phone);
_.ensureInstanceOf('string',role);
_.ensureInstanceOf(FatigueMeterType,fatigueMeterType);
_.ensureInstanceOf(Array,enabledFeatures);
_.ensureInstanceOf('boolean',isPrimary);
_.ensureInstanceOf(['string','nullable'],authConfigName);

if(_.exists(id)){
if(typeof id=='string'){
this._id=Guid.fromString(id);
}else{
_.ensureInstanceOf(Guid,id);
this._id=id;
}
}

if(_.exists(temporaryPassword))_.ensureInstanceOf('string',temporaryPassword);

let allowedRoles;



allowedRoles=['admin','manager'];


if(!_.includes(allowedRoles,role)){
throw new Error(`unknown role: ${role}`);
}

this._firstName=firstName;
this._lastName=lastName||'';
this._email=email;
this._phone=phone||'';
this._role=role;
this._fatigueMeterType=fatigueMeterType;
this._enabledFeatures=enabledFeatures;
this._isPrimary=isPrimary;
this._authConfigName=authConfigName;
this._temporaryPassword=temporaryPassword;
}UserInfo.prototype.













































toJSON=function toJSON(){
let result={
firstName:this._firstName,
lastName:this._lastName,
email:this._email,
phone:this._phone,
role:this._role,
fatigueMeterType:this._fatigueMeterType.value,
enabledFeatures:this._enabledFeatures,
isPrimary:this._isPrimary};


if(_.exists(this._authConfigName)){
result.authConfigName=this._authConfigName;
}

if(_.exists(this._id)){
result.id=this._id.toString();
}

if(_.exists(this._temporaryPassword)){
result.temporaryPassword=this._temporaryPassword;
}

return result;
};UserInfo.

fromJSON=function fromJSON(json){
return new UserInfo(json.firstName,
json.lastName,
json.email,
json.phone,
json.role,
FatigueMeterType[json.fatigueMeterType],
json.enabledFeatures,
json.isPrimary,
json.authConfigName,
json.id,
json.temporaryPassword);
};_createClass(UserInfo,[{key:'firstName',get:function(){return this._firstName}},{key:'lastName',get:function(){return this._lastName}},{key:'email',get:function(){return this._email}},{key:'phone',get:function(){return this._phone}},{key:'role',get:function(){return this._role}},{key:'fatigueMeterType',get:function(){return this._fatigueMeterType}},{key:'enabledFeatures',get:function(){return this._enabledFeatures}},{key:'isPrimary',get:function(){return this._isPrimary}},{key:'authConfigName',get:function(){return this._authConfigName}},{key:'id',get:function(){return this._id}},{key:'temporaryPassword',get:function(){return this._temporaryPassword}}]);return UserInfo}();


module.exports=UserInfo;
//# sourceMappingURL=userInfo.js.map
